const zh = {
    monthArr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    noData: '暂无数据',
    unit: {
        step: '步',
        steps: '步',
        day: '天',
        days: '天',
        time: '次',
        times: '次',
        km: '公里',
        hour: '小时',
        hours: '小时',
        kcal: '千卡',
    },
    dailyActive: {
        title: '日常活动',
        tab0: '步数',
        tab1: '运动能耗',
        unit0: '步',
        unit1: '千卡',
        time0: '周',
        time1: '月',
        time2: '年',
        time3: '日',
        math0: '最高',
        math1: '平均',
        math2: '达标占比',
        descTitle: '运动能耗',
        desc: '运动能耗指的是进行身体活动时消耗的能量，依据活动的类型、时间、强度等计算得出，不包含基础代谢。（基础代谢是指维持机体体温、心跳、呼吸、血液循环等基本生命活动所必需的最低能量代谢，在一天中随着时间的推移而累加。）',
        target: '目标进度',
        targetSet: '目标设置',
        targetDesc0: '距离完成目标还差',
        targetDesc1: '步，赶紧动起来吧~',
        targetDesc2: '千卡，赶紧动起来吧~',
        weekTitle: '周统计',
        weekRatio: '步数',
        weekDesc0: '本周您走了',
        weekDesc1: '步，相当于走了',
        weekDesc2: '圈标准操场。',
        weekCalDesc0: '本周您消耗了',
        weekCalDesc1: '千卡，相当于',
        weekCalDesc2: '。',
        weekDay: '日均',
        weekDayDesc0: '日均步数相较前一周，',
        weekDayDesc2: '日均步数与前一周持平。',
        weekDayCalDesc0: '日均能耗相较前一周，',
        weekDayCalDesc2: '日均能耗与前一周持平。',
        weekDayAdd: '增加',
        weekDayReduce: '减少',
        weekDayDesc1: '步。',
        weekDayCalDesc1: '千卡。',
        monthTitle: '月统计',
        monthTitleProp: '（本月数据不含今日）',
        monthDayDesc0: '本月您每日平均走了',
        monthDayDesc1: '步，比上月',
        monthDayDesc2: '步。',
        monthDayDesc3: '步，和上月持平。',
        monthCalDayDesc0: '本月您每日平均消耗',
        monthCalDayDesc1: '千卡，比上月',
        monthCalDayDesc2: '千卡。',
        monthCalDayDesc3: '千卡，和上月持平。',
        monthThis: '本月',
        monthLast: '上月',
        monthReach: '达标统计',
        monthReachDesc0: '本月完成目标的天数比上月',
        monthReachDesc1: '天。',
        monthReachDesc2: '本月完成目标的天数和上月持平。',
        stepTargetTitle: '目标步数',
        calTargetTitle: '目标卡路里',
        distance: '距离',
        cal: '消耗',
        distanceUnit: '公里',
        calUnit: '千卡',
        abstract: '活动摘要',
        more: '查看更多',
        all: '总步数',
        weekReach: '达标天数',
        over: '目标已达成！继续坚持，您将收获满满的活力和喜悦！',
        and: '和',
        stepToDC0: '相当于走了',
        stepToDC1: '圈标准操场，消耗了',
        stepToDC2: '。',
        calTCal0: '相当于消耗了',
        allCal: '总消耗',
        noAbstract: '数据不足，无法展示摘要内容~',
    },
    abstract: {
        title: '活动摘要'
    },
    hr: {
        title: '心率',
        unit: '次/分',
        resting: '静息',
        time0: '日',
        time1: '周',
        time2: '月',
        time3: '年',
        math0: '最高',
        math1: '最低',
        math2: '平均心率',
        math3: '平均静息',
        descTitle: '静息心率',
        desc: '静息心率为清晨起床前空腹心率，是衡量心脏健康的重要指标之一。理想的静息心率是 60~80 次/分钟，不在理想范围内的人发生心血管疾病的概率较高，可通过进行适宜强度的运动使静息心率趋于理想。',
        noData: '暂无数据',
        ecgTitle: '心电数据',
        ecgFrom0: '由',
        ecgFrom1: '心电设备采集',
        conclude: {
            "无有效结果": '无有效结果；',
            "未见明显异常": '未见明显异常；',
            "疑似房颤": '疑似房颤；',
            "疑似心动过速": '疑似心动过速；',
            "疑似心动过缓": '疑似心动过缓；',
            "疑似长RR间期": '疑似长RR间期；',
            "疑似偶发室性早搏": '疑似偶发室性早搏；',
            "疑似频发室性早搏": '疑似频发室性早搏；',
            "疑似室性心动过速": '疑似室性心动过速；',
            "疑似偶发室上性早搏": '疑似偶发室上性早搏；',
            "疑似频发室上性早搏": '疑似频发室上性早搏；',
            "疑似室上性心动过速": '疑似室上性心动过速；'
        }
    },
    hrDesc: {
        title: '心率失常',
        title0: '心动过速',
        desc0: '瞬时心率高于100次/分钟占比。心动过速分生理性和病理性两种。跑步、情绪激动等情况下心率加快为生理性心动过速；高热、贫血等疾病引起的心动过速称为病理性心动过速。',
        title1: '心动过缓',
        desc1: '瞬时心率低于60次/分钟占比。心动过缓有几种类型，最常见的是窦性心动过缓。心率小于50次/分钟多数为病理性，通常需要治疗。',
        title2: '心律不齐或早搏：',
        desc2: '窦性心律不齐或早搏节律占比。早搏包括室性早搏和室上性早搏，是临床上非常常见的心律失常，其发生人群相当广泛，包括正常健康人群和各种心脏病患者。早搏小于5次/分为偶发，大于5次/分为频发。',
        title3: '室上性早搏',
        desc3: '室上性早搏，起源于窦房结以外的心房提前激动，是一种常见的心律失常，见于正常健康人群和任意类型心脏病患者。室上性早搏发作频率随年龄的增长而增加。室上性早搏主要症状为心悸、心脏停跳感等。大于5次/分钟或30次/小时为频发室上性早搏。',
        title4: '室性早搏',
        desc4: '室性早搏指起源于心室的心律紊乱，是非常常见的心律失常，常见于正常健康人群和各种心脏病患者。正常人发生室早的频率随年龄的增长而增加。室性早搏最常见的症状是心悸，有时患者会有心前区重击感及头晕等症状。大于5次/分钟或30次/小时为频发室性早搏。',
        title5: '房颤',
        desc5: '心房颤动简称房颤，是最常见的持续性心律失常，通常表现为快而不规则的心率。房颤发生率与冠心病、高血压病和心力衰竭等心脏疾病有密切关系，随着年龄增长房颤的发生率不断增加（75岁以上人群可达10%），并可能引发脑卒中等严重的并发症。',
        title6: '长RR间期',
        desc6: '长RR间期一般是指心电图中大于或等于1.5s的RR间期，是动态心电图检查中重要的监测指标之一。引起长RR间期最常见的心律失常类型主要有心房颤动或心房扑动、窦性停搏、房室传导阻滞等。',
    },
    ecgDesc: {
        title: '心脏健康得分',
        title0: '心脏健康得分',
        desc0: '心脏健康得分，按照本次心电测量计算的节律分析和心律失常事件并按照一定的权重策略计算所得，如果发现的心律失常事件和节律异常事件越少说明心脏健康得分就越高，反之亦然，具体得分对照如下：',
        level0: '差：＜60',
        level1: '较差：60-69',
        level2: '一般：70-79',
        level3: '良好：80-89',
        level4: '优：≥90',
        title1: '结论和建议',
        desc1: '根据心律失常事件和节律异常事件进行自动生成，仅供参考，不直接作为临床诊断的依据。对提示风险或有身体不适的用户，建议及时到正规医疗机构进行进一步的咨询和检查。'
    },
    hrvDesc: {
        title: 'HRV指数',
        title0: 'HRV指数',
        desc0: 'HRV指数即心率变异性，它是指心率节奏快慢随时间所发生的变化，用于分析逐个心动周期的细微时间变化及其规律，主要反映自主神经对心脏的调节能力。心率变异性越高，表示神经对心血管系统调节能力越好，HRV较差时应注意休息和情绪控制，如出现心脏不舒服等问题请及时就医检查，具体得分对照如下：',
        level0: '差：0-21',
        level1: '中：21-34',
        level2: '良：34-47',
        level3: '优：>47',
    },
    sleep: {
        title: '睡眠',
        time0: '日',
        time1: '周',
        time2: '月',
        fallAsleep: '入睡',
        wakeUp: '醒来',
        level0: '优',
        level1: '中',
        level2: '差',
        hour: ' 时 ',
        minute: ' 分',
        sleepStage: '睡眠分期',
        stage0: '深睡',
        stage1: '浅睡',
        stage2: '快速眼动',
        stage3: '清醒',
        mathTitle: '睡眠统计',
        math0: '平均睡眠时长',
        math1: '最短睡眠时长',
        math2: '最长睡眠时长',
        ratioLevel0: '深睡比例（参考值：20~60%）',
        ratioLevel1: '浅睡比例（参考值：＜55%）',
        ratioLevel2: '快速眼动比例（参考值：10~30%）',
        ratioLevel3: '清醒次数（参考值：≤1次）',
        ratioNormal: '正常',
        ratioHigh: '偏高',
        ratioLow: '偏低',
        sportLevel: '运动强度',
        other: '睡眠建议',
        other0: '您比',
        other1: '的用户睡得早',
        other2: '您比',
        other3: '的用户起得早',
        stageTitle: '分期统计',
        stageKey0: '平均深睡时长',
        stageKey1: '平均浅睡时长',
        stageKey2: '平均快速眼动时长',
        stageKey3: '平均清醒时长',
        fallTitle: '入睡时间',
        dayTitle: '日均统计',
        averageDesc0: '本周日均睡眠时长对比上周',
        averageDesc1: '本月日均睡眠时长对比上月',
        averageDesc2: '增加',
        averageDesc3: '减少',
        averageDesc5: '持平。',
        averageDesc4: '。',
        averageDesc6: '',
        averageDesc7: '',
        scoreTitle: '睡眠得分',
    },
    sleepStage: {
        title: '睡眠分期',
        desc0: '睡眠分期是为了研究方便而根据脑电波和生理表现人为划定的，实际上各个睡眠阶段很难划出明确的界线，往往是逐渐变化，重叠交错，各有所侧重的。人的睡眠，一夜中大约有4~6个睡眠周期出现，互相连接，周而复始。每天保证充足的睡眠对于维持身心健康非常有益，研究表明成年人合适的睡眠时长为：6-10小时，睡眠时间不是睡眠质量的唯一标准，长时间的睡眠不一定能弥补睡眠不足，有时候反而不利于得到高质量的睡眠，我们应该合理作息时间来提高睡眠质量。',
        title1: '深睡阶段',
        desc1: '脑电波频率明显变慢，呼吸频率和血压也明显降低，大脑可以得到充分的休息，在深睡阶段被唤醒会出现头晕、心悸、烦躁等症状，深睡时间越长，睡眠质量也越好，如果深睡过长可能是某些疾病发作的信号，建议寻找专业医生咨询。',
        title2: '浅睡阶段',
        desc2: '脑电波减慢，心率和呼吸速度放慢，人进入了睡眠但是容易被唤醒，浅睡是一种正常的现象，有助于人快速醒来，但是，如果浅睡占比过大，睡眠质量无法得到保证，容易出现困乏。',
        title3: '快速眼动阶段',
        desc3: '人的眼球快速来回移动，该阶段人们一般都处于梦境中，在该阶段为了避免人们梦中做出动作，肌肉会处于松弛瘫痪状态。',
        title4: '清醒阶段',
        desc4: '夜间清醒并不是真正的清醒，可能人们并没有意识到自己已经觉醒，处于觉醒的临界状态，一般情况下觉醒总时间小于总睡眠时间的10%，夜间清醒时间和次数过多都可能是失眠导致，建议寻找专业医生咨询。',
    },
    bos: {
        title: '血氧饱和度',
        time0: '日',
        time1: '周',
        time2: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '正常',
        level1: '轻度缺氧',
        level2: '中度缺氧',
        descTitle: '血氧饱和度',
        desc0: '血氧饱和度(SaO2)是血液中被氧结合的氧合血红蛋白(HbO2)的容量占全部可结合的血红蛋白容量的百分比，即血液中血氧的浓度，它是呼吸循环的重要生理参数。',
        desc1: '血氧值结果说明：95%-100% 正常；90%-94% 轻度缺氧；70%-89% 中度缺氧。',
        desc2: '本功能仅供参考，不作为医疗诊断依据，如有不适请立即向医疗机构咨询。'
    },
    pressure: {
        title: '身体压力',
        time0: '日',
        time1: '周',
        time2: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '偏高',
        level1: '中等',
        level2: '正常',
        level3: '放松',
        descTitle: '身体压力',
        desc0: '本设备是根据HRV（心率变异率）等数据，通过算法得出目前承受的压力值。通过压力数值可以了解自己的身体压力状态，承受较高压力时，及时进行减压，有助于身体健康。',
        desc1: '压力结果说明：1-29 放松；30-59 正常；60-79 中等；80-99偏高'
    },
    fitnessAge: {
        title: '体能年龄',
        time0: '周',
        time1: '月',
        unit: '岁',
        actualAge: '实际年龄',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '体能年龄',
        desc: '体能年龄是由您的最大摄氧量推算。此指标说明在运动中，人体所能达到可被肌肉使用的最大氧气摄取速率，一般而言VO2max越高，有氧能力越好。'
    },
    staminaLevel: {
        title: '体能等级',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '初学者',
        level1: '运动新手',
        level2: '挑战者',
        level3: '运动者',
        level4: '运动爱好者',
        level5: '运动狂热者',
        level6: '菁英运动员',
        unit0: '体能等级',
        unit1: '有氧',
        unit2: '无氧',
        descTitle: '体能等级',
        desc0: '体能等级可反应出最佳状态下的运动表现潜力，为一综合型指标。其中有氧运动的体能等级可用来判断您在中长距离的能力表现，无氧运动的体能等级则用来判断您在短中距离的能力表现。',
        desc1: '体能等级值说明：10-19.9 初学者；20-29.9 运动新手；30-39.9 挑战者；40-49.9 运动者；50-59.9 运动爱好者；60-69.9 运动狂热者；70-80.9 菁英运动员。'
    },
    trainingLoad: {
        title: '短期负荷',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '低',
        level1: '最佳',
        level2: '高',
        descTitle: '短期负荷',
        desc0: '训练负荷可反应目前的身体负荷程度，借以在运动前调整当次训练的强度和时间，达到最佳的训练安排，并降低受伤的风险。',
        desc1: '短期负荷值说明：',
        desc2: '＜0.8 负荷低；',
        desc3: '0.8-1.5 负荷最佳；',
        desc4: '＞1.5 负荷高。'
    },
    trainingStatus: {
        title: '训练状态',
        time0: '周',
        time1: '月',
        level0: '无状态期',
        level1: '过度训练期',
        level2: '停止训练期',
        level3: '退步期',
        level4: '维持期',
        level5: '恢复期',
        level6: '进步期',
        level7: '减量期',
        descTitle: '训练状态',
        desc0: '训练状态为评估跑步或自行车运动的训练状况指标。观察过去7天训练负荷与体力等级的变化趋势，可为后续运动训练提供训练指引。',
        desc1: '无状态期：过去7天无训练或距离第一次训练未满7天',
        desc2: '过度训练期：建议降低训练负荷，增加恢复时间',
        desc3: '停止训练期：建议开始训练以达到正向的训练适应',
        desc4: '退步期：建议检视训练计划，调整训练负荷',
        desc5: '维持期：建议提高训练负荷以达到正向的训练适应',
        desc6: '恢复期：建议适当增加训练负荷以避免体能等级下降',
        desc7: '进步期：建议维持目前的训练状态',
        desc8: '减量期：建议关注体能等级变化以微调训练负荷',
    },
    vo2max: {
        title: '最大摄氧量',
        time0: '周',
        time1: '月',
        level0: '很差',
        level1: '不良',
        level2: '普通',
        level3: '良好',
        level4: '优异',
        level5: '顶尖',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '最大摄氧量',
        desc: '最大摄氧率可定义为在剧烈运动期间，身体吸收和利用氧气的最高速率。它经常用以代表个人的心肺适能。',
        age: '年龄'
    },
    lactate: {
        title: '乳酸阈',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '乳酸阈',
        unit0: '公里',
        unit1: '次/分',
        type0: '乳酸阈配速',
        type1: '乳酸阈心率',
        desc0: '乳酸阈配速是指在运动时身体可承受的乳酸浓度 (大约相对于 88-92% 最大心率) 下最快的跑步配速。',
        desc1: '在运动时达到最大乳酸稳定状态 (MLSS)，乳酸阈值心率即发生在此阶段，一般约落在88-92% 最大心率，低于此运动强度表示能长时间持续运动不致疲劳。'
    },
    forecast: {
        title: '跑步成绩预测',
        title0: '最新成绩',
        level2: '半马',
        level3: '全马',
        title1: '最佳成绩',
        descTitle: '跑步成绩预测',
        desc: '基于用户的体能等级状态，来预估个人在不同距离跑步时能够达到的最佳成绩，监测您在较长时间内跑步成绩提高的情况。',
        prot: '数据来自'
    },
    basicHr: {
        title: '基础心率',
        time0: '周',
        time1: '月',
        unit: '次/分',
        math0: '最高心率',
        math1: '最低心率',
        math2: '平均基础',
        descTitle: '基础心率',
        desc: '基础心率为清晨起床前空腹心率，是衡量心脏健康的重要指标之一。理想的基础心率是 50~80 次/分钟，不在理想范围内的人发生心血管疾病的概率较高，可通过进行适宜强度的运动使基础心率趋于理想。'
    },
    sportType: {
        其他: '其他',
        全部运动: '全部运动',
        健走: '健走',
        跑步: '跑步',
        骑行: '骑行',
        室内游泳: '室内游泳',
        户外游泳: '户外游泳',
        操场跑: '操场跑',
        徒步越野: '徒步越野',
        徒步穿越: '徒步穿越',
        马拉松: '马拉松',
        铁人三项: '铁人三项',
        深蹲: '深蹲',
        划船机: '划船机',
        椭圆机: '椭圆机',
        卷腹: '卷腹',
        自由训练: '自由训练',
        跳绳: '跳绳',
        俯卧撑: '俯卧撑',
        平板支撑: '平板支撑',
        室内跑: '室内跑',
        射箭: '射箭',
        拳击: '拳击',
        爬楼: '爬楼',
        越野跑: '越野跑',
        登山: '登山',
        轮滑: '轮滑',
        骑马: '骑马',
        皮划艇: '皮划艇',
        冲浪: '冲浪',
        帆板: '帆板',
        越野骑行: '越野骑行',
        越野滑雪: '越野滑雪',
        滑雪登山: '滑雪登山',
        室内攀岩: '室内攀岩',
        户外攀岩: '户外攀岩',
        飞盘: '飞盘',
        跳伞: '跳伞',
        篮球: '篮球',
        足球: '足球',
        网球: '网球',
        羽毛球: '羽毛球',
        乒乓球: '乒乓球',
        力量训练: '力量训练',
        室内步行: '室内步行',
        障碍赛跑: '障碍赛跑',
        越野摩托: '越野摩托',
        摩托艇: '摩托艇',
        漂流: '漂流',
        风筝冲浪: '风筝冲浪',
        滑水: '滑水',
        浮潜: '浮潜',
        赛艇: '赛艇',
        龙舟: '龙舟',
        跳水: '跳水',
        有氧运动: '有氧运动',
        室内单车: '室内单车',
        踏步机: '踏步机',
        爬楼机: '爬楼机',
        漫步机: '漫步机',
        瑜伽: '瑜伽',
        普拉提: '普拉提',
        空手道: '空手道',
        跆拳道: '跆拳道',
        HIIT: 'HIIT',
        体操: '体操',
        单杠: '单杠',
        双杠: '双杠',
        户外滑冰: '户外滑冰',
        室内滑冰: '室内滑冰',
        单板滑雪: '单板滑雪',
        双板滑雪: '双板滑雪',
        冰壶: '冰壶',
        雪地摩托: '雪地摩托',
        雪橇: '雪橇',
        雪车: '雪车',
        雪鞋徒步: '雪鞋徒步',
        蹦极: '蹦极',
        跑酷: '跑酷',
        BMX: 'BMX',
        赛车: '赛车',
        水球: '水球',
        排球: '排球',
        棒球: '棒球',
        橄榄球: '橄榄球',
        曲棍球: '曲棍球',
        门球: '门球',
        板球: '板球',
        台球: '台球',
        保龄球: '保龄球',
        匹克球: '匹克球',
        壁球: '壁球',
        垒球: '垒球',
        冰球: '冰球',
        手球: '手球',
        舞蹈: '舞蹈',
        太极拳: '太极拳',
        健身操: '健身操',
        武术: '武术',
        击剑: '击剑',
        滑板: '滑板',
        摔跤: '摔跤',
        钓鱼: '钓鱼',
        体感游戏: '体感游戏'
    },
    challengeType: {
        type: '单人赛',
        attribute0: {
            name: '时间赛',
            attribute: '时间赛',
            desc0: '在挑战周期内，运动里程累计达到',
            desc1: '公里，用时越短排名靠前。（请在运动后及时同步数据，排名榜单会实时更新）'
        },
        attribute1: {
            name: '距离赛',
            attribute: '距离赛',
            desc: '在挑战周期内，运动累计距离越长排名越靠前。（请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute1骑行: {
            name: '骑行大挑战',
            attribute: '距离赛',
            desc: '在挑战周期内，骑行累计距离越长排名越靠前。（请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute1跑步: {
            name: '跑步大挑战',
            attribute: '距离赛',
            desc: '在挑战周期内，跑步累计距离越长排名越靠前。（请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute2: {
            name: '燃脂赛',
            attribute: '燃脂赛',
            desc: '在挑战周期内，在指定运动中累计消耗卡路里越多排名越靠前 。（请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute3: {
            name: '速度赛',
            attribute: '速度赛',
            desc: '在挑战周期内，单次平均配速越快排名越靠前。 （请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute3骑行: {
            name: '骑行速度赛',
            attribute: '速度赛',
            desc: '在挑战周期内，骑行单次平均配速越快排名越靠前。 （请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute3跑步: {
            name: '跑步速度赛',
            attribute: '速度赛',
            desc: '在挑战周期内，跑步单次平均配速越快排名越靠前。 （请在运动后及时同步数据，排行榜单会实时进行更新）'
        },
        attribute4: {
            name: '步数挑战赛',
            type: '单人赛',
            desc: '运动模式内，步数越高排名越靠前 （请在运动后及时同步数据，排行榜单会实时进行更新）',
        }
    },
    challengeList: {
        title: '对抗挑战',
        history: '历史挑战',
        join: '参战人数'
    },
    challengeDesc: {
        medalPop: '恭喜你获得本次挑战的',
        accept: '开心收下',
        over: '已结束',
        no0: '第',
        no1: '名',
        end0: '距结束',
        end1: '天',
        rDistance0: '剩余距离',
        distanceUnit: '千米',
        tDistance: '总距离',
        race: '最快配速',
        cal: '总燃脂',
        calUnit: '千卡',
        step: '总步数',
        stepUnit: '步',
        down: '下拉查看进程',
        up: '上拉收起',
        range: '挑战周期',
        type: '挑战类型',
        typeValue: '单人赛',
        attribute: '挑战属性',
        attributeArr: ['时间赛', '距离赛', '燃脂赛', '速度赛', '步数赛'],
        sport: '运动类型',
        tab0: '详情',
        tab1: '排行榜',
        descTitle: '赛制说明',
        top3: '前三甲勋章',
        medalFinish: '获得本次挑战的',
        noMedal: '未获得勋章，下次努力哦~',
        joining: '立即加入',
        tableTitle0: '名次',
        tableTitle1: '用户',
        tableTitle2: '剩余距离',
        tableTitle3: '用时',
        tableTitle4: '总距离',
        tableTitle5: '总燃脂',
        tableTitle6: '最快配速',
        tableTitle7: '总步数',
        join: '参战人数'
    },
    sportRecord: {
        title: '运动纪录',
        record0: {
            name: '步数',
            record0: '单日最多纪录(步)',
            record1: '单周最多纪录(步)',
            record2: '单月最多纪录(步)'
        },
        record1: {
            name: '跑步',
            record0: '单次最长里程(公里)',
            record1: '最佳配速',
        },
        record2: {
            name: '骑行',
            record0: '单次最长里程(公里)',
            record1: '最佳配速',
        },
        record3: {
            name: '游泳',
            record0: '单次最长里程(公里)',
            record1: '最佳SWOLF',
        },
        record4: {
            name: '登山',
            record0: '单次最大高度(米)',
        }
    },
    sportCount: {
        title: '运动统计',
        time0: '周',
        time1: '月',
        unit0: '公里',
        unit1: '分钟',
        item1: '运动次数',
        item1Unit: '次',
        item2: '运动时长',
        item2Unit: '小时',
        item3: '总距离',
        item4: '运动能耗',
        item4Unit: '千卡',
    },
    newSportList: {
        title: '运动报告',
        type0: '运动周报',
        type1: '运动月报',
        type2: '运动年报',
    },
    newWeek: {
        title: '运动周报',
        step: '步',
        day: '天',
        stepDesc0: '本周你比',
        stepDesc1: '的人走得多',
        time: '次',
        km: '公里',
        hour: '小时',
        kcal: '千卡',
    },
    newMonth: {
        title: '运动月报',
        step: '步',
        steps: '步',
        day: '天',
        days: '天',
        time: '次',
        times: '次',
        km: '公里',
        hour: '小时',
        hours: '小时',
        kcal: '千卡',
        noMedal: '没有新增哦，下个月加油~',
        add0: '新增',
        add1: '枚',
        more0: '超过',
        more1: '的人'
    },
    newWeekHistory: {
        title: '历史周报',
        no: '下面没有啦~'
    },
    newMonthHistory: {
        title: '历史月报',
        no: '下面没有啦~'
    },
    newYearHistory: {
        title: '历史年报',
        no: '下面没有啦~'
    },
    feedback: {
        title: '意见反馈',
        prop: '请描述你遇到的问题或提出优化建议，我们一定会认真对待！',
        contact: '联系方式',
        contactValue: '手机号/QQ/微信号/邮箱',
        submit: '提交'
    },
    medal: {
        title: '我的勋章',
        tab0: '运动勋章',
        tab1: '北斗勋章',
        tab2: '挑战勋章',
        get0: '已获得',
        get1: '枚勋章',
        step: '步行',
        run: '跑步',
        ride: '骑行',
        swim: '游泳',
        climb: '登山',
        marathon: '马拉松',
        sport: '运动'
    },
    selectCityApp: {
        title: '城市选择',
        current: '当前城市'
    },
    prodInstructions: {
        title: '操作说明',
        video: '操作视频',
        desc: '详细说明',
        quick: '快速入门',
        question: '常见问题',
        compass: '指北针检测不准？',
        compass700: '指南针检测不准？',
        sleep: '正常佩戴无睡眠数据？',
        height: '海拔高度不准？',
        ecg: '心电无法测量/结果不准确？',
        android: 'Android手机消息无法推送到手表？',
        ios: 'iOS手机消息无法推送到手表？',
        keepAlive: '如何进行保活设置？',
        restricted: '手机开启权限提示“受限制的设置”？',
        map: '如何下载地图？'
    },
    keepAlive: {
        title: '保活设置',
        desc: '为了保证Aswear能够在后台正常运行，保证蓝牙连接稳定，用户可以参考下面对应机型进行设置。',
        tabArr: ['小米', '华为', 'vivo', 'OPPO', '一加', 'realme', '荣耀', '联想', '魅族', '三星'],
        xiaomi: {
            p0: '1 小米',
            p1: '1.1 小米手机允许后台活动',
            p2: '点击去设置 - 【手机设置】- 【应用设置】- 【应用管理】- 【Aswear】- 【省电策略】- 设置为【无限制】。',
            p3: '1.1.1 应用设置',
            p4: '1.1.2 应用管理',
            p5: '1.1.3 Aswear',
            p6: '1.1.4 省电策略',
            p7: '1.1.5 设置为无限制',
            p8: '1.2 小米手机自启动权限设置',
            p9: '点击去设置-【手机设置】-【应用设置】-【应用管理】-【Aswear】- 【自启动】- 开启【自启动】。',
            p10: '1.2.1 应用设置',
            p11: '1.2.2 应用管理',
            p12: '1.2.3 Aswear',
            p13: '1.2.4 开启自启动开关',
            p14: '1.3 锁定后台任务',
            p15: '①点击底部上滑悬停调出后台任务；',
            p16: '②长按“Aswear”APP，点击“锁”图标就可将该应用锁定。'
        },
        huawei: {
            p0: '2 华为',
            p1: '2.1 华为手机锁定后台任务',
            p2: '从屏幕底部向上滑动 - 进入多任务页面 - 找到Aswear - 向下滑动Aswear - 锁定Aswear。',
            p3: '2.2 华为手机允许后台活动',
            p4: '点击去设置 - 【手机设置】- 【应用和服务】- 【应用启动管理】- 【Aswear】，开启 【允许自启动】和【允许后台活动】开关。',
            p5: '2.2.1 应用和服务',
            p6: '2.2.2 应用启动管理',
            p7: '2.2.3 Aswear',
            p8: '2.2.4 允许后台活动',
            p9: '2.2.5 点击确定'
        },
        vivo: {
            p0: '3 vivo',
            p1: '3.1 vivo手机允许后台活动',
            p2: '点击去设置 - 【手机设置】- 【电池】- 【后台高耗电】- 【Aswear】，开启【后台高耗电】。',
            p3: '3.1.1 电池',
            p4: '3.1.2 后台高耗电',
            p5: '3.1.3 Aswear',
            p6: '3.1.4 开启后台高耗',
            p7: '3.2 vivo手机自启动权限设置',
            p8: '点击去设置-【手机设置】-【应用与权限】-【权限管理】-【自启动】-【Aswear】，开启【自启动】。',
            p9: '3.2.1 应用与权限',
            p10: '3.2.2 权限管理',
            p11: '3.2.3 自启动',
            p12: '3.2.4 开启Aswear开关'
        },
        oppo: {
            p0: '4 OPPO',
            p1: '4.1 OPPO手机允许后台活动',
            p2: '点击去设置 - 【电池】- 【应用耗电管理】- 【Aswear】，开启【允许完全后台行为】- 弹窗设置【允许】。',
            p3: '4.1.1 电池',
            p4: '4.1.2 应用耗电管理',
            p5: '4.1.3 Aswear',
            p6: '4.1.4 允许完全后台行为',
            p7: '4.1.5 点击允许',
            p8: '4.2 OPPO手机自启动权限设置',
            p9: '点击去设置-【手机设置】-【应用管理】-【自启动管理】-【Aswear】- 开启【后台自启动】。',
            p10: '4.2.1 应用管理',
            p11: '4.2.2 自启动管理',
            p12: '4.2.3 开启Aswear开关'
        },
        yijia: {
            p0: '5 一加',
            p1: '5.1 一加手机锁定后台任务',
            p2: '从屏幕底部向上滑动 - 进入多任务页面 - 找到Aswear - 点击更多按钮 - 点击锁定Aswear。',
            p3: '5.2 一加手机允许后台活动',
            p4: '点击去设置 - 【手机设置】- 【电池】- 【应用耗电管理】- 【Aswear】，开启 【允许完全后台行为】- 设置为【允许】。',
            p5: '5.2.1 电池',
            p6: '5.2.2 应用耗电管理',
            p7: '5.2.3 Aswear',
            p8: '5.2.4 允许完全后台行为',
            p9: '5.2.5 点击允许',
            p10: '5.3 一加手机自启动权限设置',
            p11: '点击去设置-【手机设置】-【应用管理】-【自启动管理】-【Aswear】- 开启【后台自启动】。',
            p12: '5.3.1 应用管理',
            p13: '5.3.2 自启动管理',
            p14: '5.3.3 Aswear'
        },
        realme: {
            p0: '6 realme',
            p1: '6.1 realme手机锁定后台任务',
            p2: '从屏幕底部向上滑动 - 进入多任务页面 - 找到Aswear - 点击更多按钮 - 点击锁定Aswear。',
            p3: '6.2 realme手机允许后台活动',
            p4: '点击去设置 - 【手机设置】- 【电池】- 【应用耗电管理】- 【Aswear】，开启 【允许完全后台行为】- 设置为【允许】。',
            p5: '6.2.1 电池',
            p6: '6.2.2 应用耗电管理',
            p7: '6.2.3 Aswear',
            p8: '6.2.4 允许完全后台行为',
            p9: '6.2.5 点击允许',
            p10: '6.3 realme手机自启动权限设置',
            p11: '点击去设置-【手机设置】-【应用管理】-【自启动管理】-【Aswear】- 开启【后台自启动】。',
            p12: '6.3.1 应用管理',
            p13: '6.3.2 自启动管理',
            p14: '6.3.3 Aswear'
        },
        rongyao: {
            p0: '7 荣耀',
            p1: '7.1 荣耀手机锁定后台任务',
            p2: '从屏幕底部向上滑动 - 进入多任务页面 - 找到Aswear - 向下滑动Aswear - 锁定Aswear。',
            p3: '7.2 荣耀手机允许后台活动',
            p4: '点击去设置 - 【手机设置】- 【应用和服务】- 【应用启动管理】- 【Aswear】，开启 【允许自启动】和【允许后台活动】开关。',
            p5: '7.2.1 应用和服务',
            p6: '7.2.2 应用启动管理',
            p7: '7.2.3 Aswear',
            p8: '7.2.4 允许后台活动',
            p9: '7.2.5 点击确定'
        },
        lianxiang: {
            p0: '8 联想',
            p1: '8.1 联想手机允许后台活动',
            p2: '点击去设置 - 【手机设置】- 【应用和通知】- 【特殊应用权限】- 【电池优化】- 【Aswear】，弹窗选择【不优化】，点击完成。',
            p3: '8.1.1 应用和通知',
            p4: '8.1.2 特殊应用权限',
            p5: '8.1.3 电池优化',
            p6: '8.1.4 Aswear',
            p7: '8.1.5 选择不优化',
            p8: '8.1.6 点击完成',
            p9: '8.2 联想手机自启动权限设置',
            p10: '点击去设置-【手机设置】-【应用和通知】-【查看全部应用】-【Aswear】-【权限】-【应用自启】，弹窗选择【允许】，点击完成。',
            p11: '8.2.1 应用和通知',
            p12: '8.2.2 查看全部应用',
            p13: '8.2.3 Aswear',
            p14: '8.2.4 权限',
            p15: '8.2.5 应用自启',
            p16: '8.2.6 选择允许'
        },
        meizu: {
            p0: '9 魅族',
            p1: '9.1 魅族手机允许后台活动',
            p2: '点击去设置 - 【手机设置】- 【隐私和权限】- 【后台管理】- 【Aswear】，选择【允许后台运行】。',
            p3: '9.1.1 隐私和权限',
            p4: '9.1.2 后台管理',
            p5: '9.1.3 Aswear',
            p6: '9.1.4 选择允许后台运行',
            p7: '9.2 魅族手机锁定后台任务',
            p8: '从屏幕底部向上滑动 - 进入多任务页面 - 找到Aswear - 下滑Aswear - 点击锁定Aswear。'
        },
        sanxing: {
            p0: '10 三星',
            p1: '10.1 三星手机锁定后台任务',
            p2: '从屏幕底部向上滑动 - 进入多任务页面 - 找到Aswear - 长按Aswear - 点击锁定Aswear。',
            p3: '10.2 三星手机允许后台活动',
            p4: '点击去设置 - 【手机设置】- 【应用程序】- 【Aswear】- 【电池】，开启【允许后台活动】。',
            p5: '10.2.1 应用程序',
            p6: '10.2.2 Aswear',
            p7: '10.2.3 电池',
            p8: '10.2.4 允许后台活动',
            p9: '10.3 三星手机自启动权限设置',
            p10: '点击去设置-【手机设置】-【常规管理】-【电池】-【后台使用限制】-【自动运行应用程序】-【Aswear】- 开启【允许后台活动】。',
            p11: '10.3.1 常规管理',
            p12: '10.3.2 电池',
            p13: '10.3.3 后台使用限制',
            p14: '10.3.4 自动运行应用程序',
            p15: '10.3.5 开启Aswear自运行开关',
            p16: '【更多知识】',
            p17: '手机开启权限提示“受限制的设置”的解决方式'
        }
    },
    androidMessageSet: {
        title: 'Android手机消息无法推送到手表？',
        p0: '消息推送原理：',
        p1: '手表连接Android手机后，系统获取手机通知栏通知，推送给您的手表。',
        p2: '如果您发现手表没有收到对应',
        p3: '应用',
        p4: '消息，以',
        p5: '微信',
        p6: '为例，请尝试如下操作：',
        p7: '1.进入手机设置，搜索并进入',
        p8: '“权限管理>右上角>特殊访问权限>通知使用权>Aswear APP”',
        p8end: '。',
        p9: '2.在',
        p10: '“AswearAPP>我的设备>消息提醒”',
        p11: '，并打开需要推送消息的应用开关。',
        p12: '3.确保信息可以显示在手机通知栏：此处已华为HarmonyOS 3.0手机为例，选择',
        p13: '“设置>通知和状态栏”',
        p14: '，点击您需要通知的应用，设置为',
        p15: '允许通知',
        p16: '，并设置该应用各类别消息的通知方式（铃声、振动、横幅、锁屏通知、允许打扰、或桌面图标角标等），并',
        p17: '关闭静默通知开关',
        p18: '。',
        p19: '①进入',
        p20: '通知和状态栏',
        p21: '②打开对应应用的通知开关（已微信为例）',
        p22: '③打开',
        p23: '允许通知',
        p24: '开关 ④其他类别消息通知设置（以新消息通知为例：打开',
        p25: '允许通知',
        p26: '和',
        p27: '允许打扰',
        p28: '，关闭',
        p29: '静默通知',
        p30: '）。',
        p31: '4.如果微信消息不推送或者不显示信息详情，请打开微信，选择',
        p32: '“我>设置>新消息提醒”',
        p33: '，打开',
        p34: '接收新消息通知',
        p35: '和',
        p36: '通知显示消息详情',
        p37: '开关，确保微信消息内容可以成功显示在手机状态栏。',
        p38: '①进入',
        p39: '新消息通知',
        p40: '②打开',
        p41: '通知显示消息详情',
        p42: '和',
        p43: '消息通知',
        p44: '开关',
        p45: '*微信电脑版登录时，请确保微信中的手机静音功能处于',
        p46: '关闭',
        p47: '状态：先在手机端的微信首页点击',
        p48: '横幅通知',
        p49: '，然后点击',
        p50: '手机静音',
        p51: '，将该按钮变成灰色。',
        p52: '5.强烈建议您在手机上将 Aswear APP设置为受保护的后台应用，并重启手机。设置后，可提高消息推送的稳定性。设置方法请您参考APP保活设置，点击跳转。',
        p53: '6.请您重启手表与手机尝试。',
        p54: '7.如果问题依然存在，将手表及 Aswear APP升级最新版本，并重新配对连接。',
        p55: '* Aswear APP更新：关注微信公众号“北斗卫星手表” -> 探-非凡 -> APP下载，按照界面指引进行下载。',
        p56: '手表：Aswear APP> 我的设备>固件更新。'
    },
    iosMessageSet: {
        title: 'IOS手机消息无法推送到手表？',
        p0: '消息推送原理：',
        p1: '手表连接iOS手机后，iOS系统获取手机通知栏通知，推送给您的手表。',
        p2: '3.如果发现手表仍然没有收到对应',
        p3: '应用',
        p4: '消息，以',
        p5: '微信',
        p6: '为例，请尝试如下操作：',
        p7: '确保手机系统应用通知设置正常：在',
        p8: '“手机设置>通知>微信>',
        p9: '打开',
        p10: '允许通知',
        p11: '开关',
        p12: '>勾选锁定屏幕、通知中心、横幅”；显示预览',
        p13: '选择',
        p14: '始终，横幅风格',
        p15: '选择',
        p16: '持续',
        p17: '。',
        p18: '①进入设置',
        p19: '通知',
        p20: '②找到',
        p21: '微信',
        p22: '。',
        p23: '③打开',
        p24: '允许通知',
        p25: '开关 ④勾选',
        p26: '锁定屏幕、通知中心、横幅',
        p27: '。',
        p28: '⑤',
        p29: '显示预览',
        p30: '选择',
        p31: '始终',
        p32: '⑥',
        p33: '横幅风格',
        p34: '选择',
        p35: '持续',
        p36: '。',
        p45: '2.如果Aswear消息不推送，请打开应用APP，选择',
        p46: '设备>消息提醒',
        p47: '，打开对应',
        p48: '消息类型通知开关',
        p49: '。',
        p50: '①进入 设备②进入',
        p55: '消息提醒',
        p56: '③打开对应消息类型',
        p57: '通知开关',
        p58: '。',
        p59: '4.请您重启手表与手机尝试。',
        p60: '5.如果问题依然存在，将手表及',
        p61: 'Aswear',
        p62: 'APP升级最新版本，并重新配对连接。',
        p63: '* Aswear APP更新：',
        p64: '在App Store中搜索 Aswear APP，按照界面指引进行下载更新。',
        p65: '*手表更新路径：',
        p66: 'Aswear APP> 我的 > 我的设备 > 设备信息 > 固件更新。',
        p67: '*在连接配对时',
        p68: '手机系统会弹出允许***显示iPhone通知吗？点击',
        p69: '允许',
        p70: '。',
        p71: '如果以上方法仍未解决您的问题或者您在操作中遇到困难，请您联系店铺客服，我们将竭诚为您服务，祝您生活愉快！',
        p72: '1.确保与手表共享通知设置正常：在',
        p73: '手机设置> 蓝牙>点击已配对设备> ',
        p74: '打开',
        p75: '  共享系统通知',
        p76: '。',
        p77: '①进入设置蓝牙 ②点击 已配对的设置 ③打开 ',
        p78: '共享通知',
        p79: '手表无法接听手机电话？（适用于TA700S/G手表型号）',
        p80: '首先确保手表与手机正常连接，并尝试如下操作：',
        p81: '① ',
        p82: '手机设置> 蓝牙',
        p83: '，找到已连接的设备，点击设备。',
        p84: '② 重新加载结束后，显示',
        p85: ' 已连接 ',
        p86: '状态，然后点击右侧 ',
        p87: '感叹号 ',
        p88: '进入详情页，确保 ',
        p89: '设备类型 ',
        p90: '为 ',
        p91: '其他',
        p92: '。'
    },
    problemType: {
        title: '常见问题',
        model: '型号'
    },
    problemList: {
        title: '常见问题',
        model: '型号',
        all: '大家都在问',
        zhibeizhen: '指北针检测不准？',
        haiba: '海拔高度不准？',
        android: 'Android手机消息无法推送到手表？',
        ios: 'iOS手机消息无法推送到手表？',
        keepAlive: '如何进行保活设置？',
        prompt: '手机开启权限提示“受限制的设置”？',
        instructions: '操作说明书',
        sleep: '正常佩戴无睡眠数据？',
        map: '地图下载',
        ecg: '心电无法测量/结果不准确？'
    },
    privacyAgreement: {
        title: '隐私协议',
        p0: '本协议适用于AswearAPP(开发者:成都天奥电子股份有限公司)',
        p1: '北斗手表是由成都天奥电子股份有限公司（以下简称“我们”或者“天奥电子”）运营的为您提供户外运动和智能健康监控的系列产品及服务，产品主要为智能手表，服务主要包括Android、IOS及Windows平台下的相关app应用及微信公众号提供的相关服务等。',
        p2: '通过使用天奥电子的产品和服务，即表示您已阅读、认可并接受本隐私声明中所述之所有条款，包括我们可能随时作出的任何变更。我们承诺用法律（包括您所在地的数据保护法律）来保护您的个人信息的隐私、机密和安全。同时我们承诺我们的全体员工和代理商履行这些义务。',
        p3: '如果您对本声明有任何疑问或意见，请通过客服热线：028-87559999联系我们，我们将在一个月内回复您。',
        p4: '一、我们如何收集和使用您的个人信息',
        p5: '个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反应特定自然人活动情况的各种信息。',
        p6: '个人敏感信息是指包括身份证号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息等。',
        p7: '我们仅会处于本声明所述的以下目的，收集和使用您的个人信息。',
        p8: '1、账号登录',
        p9: '我们使用手机号码、QQ或微信作为我们的账号体系。当您使用手机号码登录时，会获取您的验证码，用于账号绑定。当您使用QQ或微信关联登录时，我们会收集您QQ或微信的唯一标识、头像、昵称。收集这些信息是用于保存您的登录信息，使您在使用不同设备登录时能够同步您的数据，保护您的账号安全。其中手机号码属于个人敏感信息，我们承诺会严格限制使用范围和严格保密。若您不提供这类信息，您可能无法正常使用我们提供的服务。',
        p10: '为何管理您的运动和健康数据，我们需要使用您的账号数据，包括您的性别、体重、身高、出生生日等，使用性别、体重、身高、出生生日是为了给你提供更好的健康建议。',
        p11: '您创建或者修改账号数据后，将自动保存在手机本地，并同步到后台服务器。',
        p12: '若设备及应用没有登录账号功能，则我们将不会记录此类数据。部分产品若没有登录账号，我们将无法为您提供在线服务。登录后若不提供性别、体重等信息，将有可能影响我们所提供建议的准确性。',
        p13: '若您想要注销账号，可以登录APP，进入“我的”页，点击“设置”栏，进入“其他设置”页，选择“账号与安全”栏，点击“注销账户”，账户注销后我们会永久删除账号及相关信息。',
        p105: '账号登录时需获取设备的唯一设备识别码（IMEI/androidID/IDFA/OPENUDID/GUID/OAID、SIM 卡 IMSI 信息等），用于设备管理和身份验证‌，保证用户登录的安全性，防止密码泄露被其他设备异地登录。',
        p14: '2、设备管理',
        p15: '为了管理北斗手表，我们需要收集您的设备信息和网络信息，设备信息包括手表设备标识符（MAC、SN等）、设备类型和设备配置参数等。收集此类信息的目的是为了建立蓝牙连接、管理设备配置信息、完成软件升级、显示数据来源。网络信息包括IP地址、网络类型和网络连接状态等，这些数据将被用来提升我们产品的网络连接体验。',
        p16: '连接设备需要访问手机蓝牙权限，但我们不会存储相关信息。我们的穿戴设备通过应用进行管理时，会将个人信息和设备配置信息通过专属安全通道传递到穿戴app应用。',
        p17: '若您不提供此类信息，则无法使用我们的穿戴设备和相关后台服务，或导致部分功能受限。',
        p18: '3、个人健康信息管理',
        p19: '在具备心电采集功能的设备和服务中，为了记录和管理您的健康数据，我们需要收集您的运动设置数据（包括运动状态、心博总数、心率区间等），心率数据分为运动心率、日常心率以及经过心率数据分析生成的在线报告，心率数据属于个人敏感信息，收集此类信息的目的是为了进行健康相关数据的测量、记录、显示以及增加心电数据分析的准确性，提升我们产品的服务质量。',
        p20: '若您不提供此类信息，则会导致我们的app应用功能受限严重，无法为您提供正常服务。',
        p21: '4、运动数据记录',
        p22: '在具备运动记录和统计功能的设备和服务中，为了记录和管理您的运动数据，我们需要收集您的设备位置、运动轨迹、运动类型、运动时长、跑步姿势、步数、距离、高度以及运动心率等，运动类型包括健走、跑步、骑行、登山、游泳、马拉松等。其中位置和轨迹属于个人敏感信息，收集此类信息的目的是记录并统计您的日常运动数据，以便在APP中为您提供运动轨迹展示功能。',
        p23: '我们会在app应用中统计并显示您的相关运动数据，如将数据作为他用，也会在经过匿名化处理之后。',
        p24: '若您不提供此类信息，则无法提供运动情况的统计、分析与展示。',
        p25: '5、征得您的授权同意的例外',
        p26: '在以下情形中，天奥电子收集、使用个人信息无需获得您的授权同意：',
        p27: '（1）与国家安全、国防安全有关的；',
        p28: '（2）与公共安全、公共卫生、重大公共利益有关的；',
        p29: '（3）与犯罪侦查、起诉、审判和判决执行等有关的；',
        p30: '（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
        p31: '（5）所收集的个人信息是个人信息主体自行向社会公众公开的；',
        p32: '（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
        p33: '（7）根据您的要求签订合同所必需的；',
        p34: '（8）用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；',
        p35: '（9）为合法的新闻报道所必需的；',
        p36: '（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；',
        p37: '（11）法律法规规定的其他情形。',
        p106: '6、基于麦克风授权的拓展功能',
        p107: '您可以选择开启系统的麦克风权限，使用语音技术来实现智能表盘、语音助手等语音交互功能。我们会收集您在使用智能语音技术过程中录入的语音信息用于机器识别、在线交互并满足您的需求。此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现在线语音交互功能，但不会影响您享受其他基本功能。',
        p38: '二、我们如何委托处理、共享、转让、公开披露您的个人信息',
        p39: '1、委托处理',
        p40: '在特殊情况下，我们有可能会委托其他公司代表我们处理您的个人信息，我们会与被委托方签署严格的保密协议或个人信息处理条款，要求他们按照本声明以及采取相关的保密和安全措施来处理个人信息。',
        p41: '2、共享',
        p42: '共享是指我们向其他个人信息控制者提供个人信息，且双方分别对个人信息拥有独立控制权的过程。我们不会对外共享您的个人信息，但以下情况除外：',
        p43: '（1）在获取明确同意情况下的共享：获得您的明确同意后，我们会向您指定的第三方共享您授权范围内的信息；',
        p44: '（2）在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息；',
        p45: '3、转让',
        p46: '转让，是指将个人信息控制权由我们向另一个个人信息控制者转移的过程。我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：',
        p47: '（1）在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；',
        p48: '（2）在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本声明的约束，否则我们将要求该公司、组织重新向您征求授权同意。',
        p49: '4、公开披露',
        p50: '我们仅会在以下情况下，公开披露您的个人信息：',
        p51: '（1）获得您的明确同意后；',
        p52: '（2）基于法律或合理依据的公开披露：在法律、法律程序、诉讼或公共和政府主管部门有要求的情况下，我们可能会公开披露您的信息；',
        p53: '5、共享、转让、公开披露个人信息时事先征得授权同意的例外',
        p54: '以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：',
        p55: '（1）与国家安全、国防安全有关的；',
        p56: '（2）与公共安全、公共卫生、重大公共利益有关的；',
        p57: '（3）与犯罪侦查、起诉、审判和判决执行等有关的；',
        p58: '（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；',
        p59: '（5）您自行向社会公众公开的个人信息；',
        p60: '（6）从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；',
        p61: '三、您的数据主体权利',
        p62: '在您使用我们的产品/服务期间，您可以访问、更正、删除您的个人信息，同时保障您撤回对个人信息使用的同意的权利，你可以：',
        p63: '1. 从我们这里获取您的个人信息；',
        p64: '2. 要求我们删除您的个人信息；',
        p65: '3. 要求我们更新您的个人信息；',
        p66: '4. 撤回赋予我们使用您个人信息的权利。',
        p67: '四、数据存储地点和期限',
        p68: '1、存储地点',
        p69: '我们在本服务项下收集和产生的个人信息，将存储在中华人民共和国境内。',
        p70: '2、存储期限',
        p71: '我们仅为实现目的所必需的时间保留您的个人信息，并在超出前述保留时间后删除或者匿名化处理您的个人信息。',
        p72: '为了您的数据安全，您的数据将和您的账号绑定，您的心电、运动等健康数据将会一直保存在我们的后台服务器中，直到您本人删除数据，或在您删除应用账号时，您的数据将会同时安全删除。',
        p73: '此外，当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。',
        p74: '五、第三方收集的信息',
        p75: '我们提供的服务可能包括属于我们的服务供应商的第三方追踪工具。该第三方可能会在我们提供的服务中使用cookies、APIs（应用程序编程接口）及SDKs（软件程序开发包），由此代表我们收集并分析用户信息。第三方可能会访问诸如您的设备标识符、MAC（媒体访问控制）地址、IMEI（移动设备国际身份码）、区域（使用给定语言的特定地点）、地理位置信息及IP地址等信息，旨在实现在其各自隐私权政策下提供服务。我们的隐私权政策不会覆盖到第三方追踪工具的使用。我们没有权限访问或控制这些第三方。',
        p76: '六、获取用户的软件安装列表',
        p77: 'APP会获取手机内安装的应用商店列表。该功能只用于展示及跳转到各应用商店，方便用户对APP进行评价及交流。我们没有权限访问或控制这些应用商店，不会也无权限将您的个人信息提交到第三方应用商店。',
        p78: '集成SDK服务及权限使用说明',
        p79: '（1）友盟+SDK',
        p80: '我们的产品集成友盟+SDK，需要允许程序收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊服务。',
        p81: '（2）个推 SDK',
        p82: '我们的产品集成个推SDK，需要允许程序手机您的设备平台、设备厂商、设备品牌、设备型号及系统版本、OAID、AndroidID、WIFI连接信息、运营商信息、设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息），以此保证消息推送的准确下发和消息设备的准确识别。',
        p83: '（3）Bugly SDK',
        p84: '我们的产品集成Bugly SDK，Android手机需要收集您的手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID、设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）；IOS手机需要收集您的设备型号、操作系统版本、操作系统内部版本号、wifi状态、cpu属性、内存剩余空间、磁盘空间/磁盘剩余空间、运行时手机状态(进程所占内存、虚拟内存等)、idfv、是否越狱、地区编码。若是APP在后台运行时发生异常，SDK可能会在后台收集终端用户的上述个人信息，用于排查处理崩溃问题。',
        p85: '附录：',
        p86: 'SDK集成以及所需权限列表',
        p87: '友盟统计',
        p88: '统计用户活跃等运营数据所需',
        p89: 'ACCESS_NETWORK_STATE、' +
            'ACCESS_WIFI_STATE、' +
            'READ_PHONE_STATE',
        p90: '个推',
        p91: '用于消息推送',
        p92: 'INTERNET、' +
            'ACCESS_NETWORK_STATE、' +
            'ACCESS_WIFI_STATE、' +
            'SCHEDULE_EXACT_ALARM、' +
            'BADGE_ICON、' +
            'READ_EXTERNAL_STORAGE、' +
            'WRITE_EXTERNAL_STORAGE、' +
            'READ_PHONE_STATE、' +
            '网络访问权限、' +
            'IDFA',
        p93: 'Bugly',
        p94: '用于收集崩溃信息',
        p95: 'INTERNET、' +
            'ACCESS_NETWORK_STAT、' +
            '网络访问权限',
        p96: '七、本声明如何更新',
        p97: '我们将保留适时更新本声明的权利，当声明发生变更时，我们会通过App或微信公众号推送通知等形式向您展示变更后的声明。只有在获得您的同意后，我们才会按照更新后的声明收集、使用和存储您的个人信息。',
        p98: '本声明自更新之日起生效。',
        p99: '最近更新日期：2024年6月6日',
        p100: '成都天奥电子股份有限公司',
        p101: '5、IP地址',
        p102: '为就近分配服务器，提高用户整体使用和访问速度，我们将收集您的IP地址。',
        p103: '（4）PushReceiver SDK',
        p104: 'PushReceiver SDK具有自启动功能，为确保本应用处于关闭或后台运行状态下可正常接收到窖户端推送的信息，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为,是因实现功能及服务所必要的。本应用须使用(自启动）能力，需要获取设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息），其目的是确保推送通道的稳定性，以便正常及时地向安卓设备推送消息。当系统发送广播时，将唤醒PushReceiver SDK自启动行为。鉴于PushReceiver SDK系以集成方式接入应用，PushReceiver SDK自启动，则应用亦随之自启动。该行为系因实现推送功能及服务所必要。'
    },
    samSet: {
        title: '手机开启权限提示“受限制的设置”的解决方式',
        p0: '这种情况常出现在摩托罗拉、三星等手机上，可以按下面两种方式处理。',
        p1: '方法一：',
        p2: '1、手机桌面长按 Aswear APP的图标 > 应用信息 > 右上角三点菜单 > 允许受限设置。',
        p3: '2、进入 手机设置 > 通知 > 设备和应用通知 > 选择 Aswear APP > 授予通知访问权限。',
        p4: '方法二：',
        p5: '以下是三星手机处理方式：',
        p6: '1、进入 手机设置 > 应用程序 > 更多选项（下图标记的3个点）',
        p7: '2、选择 ',
        p8: '特殊访问',
        p9: '3、选择 ',
        p10: '通知访问',
        p11: '4、把 ',
        p12: 'Aswear ',
        p13: '打开'
    },
    water: {
        title: '喝水助手',
        time0: '日',
        time1: '周',
        time2: '月',
        time3: '年',
        math0: '最高',
        math1: '最低',
        today: '今日饮水量',
        surplus: '剩余',
        math2: '目标完成率',
        math3: '日均最高',
        math4: '日均最低',
        chartUnit: '日均',
        descTitle: '喝水建议',
        desc: '水是构成人体的主要成分之一，为了保持良好的健康状态，确保充足的水分摄入是非常必要的。每个人的具体需求会因年龄、性别、体重、活动水平以及所处环境而有所不同。通常情况下，成年男性每日建议饮水量为2-3升，而成年女性为1.5-2.5升，具体还需根据个人情况进行调整。每日定时饮水，并使用水杯来跟踪饮水量有利于养成健康饮水的好习惯。',
        maxCountDesc: '喝水量已达到上限~'
    },
    weight: {
        title: '体重记录',
        time0: '周',
        time1: '月',
        time2: '年',
        level0: '过轻',
        level1: '正常',
        level2: '超重',
        level3: '肥胖',
        desc0: 'BMI（Body Mass Index）指数，简称体质指数，是国际上常用的衡量人体胖瘦程度以及是否健康的一个标准。计算公式为： BMI=体重÷身高的平方。（体重单位：千克；身高单位：米）。但它并不是完美的工具，尤其是在评估个体差异较大的情况下。因此，建议将BMI与其他健康指标结合使用，以获得更全面的健康评估。',
        desc1: 'BMI范围说明：＜18.5 过轻；18.5~23.9 正常；24.0~29.9 超重；＞=30 肥胖。',
        change: '变化',
        popTitle: '今日体重记录',
        height: '身高: ',
        heightPop: '身高'
    },
    planEdit: {
        title: '计划编辑',
        save: '保存',
        planName: '计划名称',
        planNameDesc: '请输入计划名称',
        action: '动作',
        actionAdd: '加动作',
        capacity: '容量',
        group: '组',
        weight: '重量',
        frequency: '次',
        distance: '距离',
        duration: '用时',
        duration1: '时长',
        common: '共',
        inputPlaceholder: '请输入有效必填项',
        actionListPlaceholder: '至少添加一个动作',
        success: '操作成功！'
    },
    actionLibrary: {
        title: '动作库',
        searchDesc: '请输入动作名称进行搜索',
        action1: '全身',
        action2: '肩颈',
        action3: '手臂',
        action4: '胸部',
        action5: '背部',
        action6: '腰腹',
        action7: '臀腿',
        action8: '自定义',
        confirm: '确认',
        customize: '自定义动作',
        customizeDesc: '创建自己的动作',
        instrument1: '徒手',
        instrument2: '哑铃凳',
        instrument3: '卧推凳',
        instrument4: '龙门架',
        instrument5: '引体向上机',
        instrument6: '瑞士球',
        instrument7: '弹力绳',
        instrument8: '仰卧板',
        instrument9: '杠铃卧推凳',
        instrument10: '哈克深蹲机',
        instrument11: '悍马腿举机',
        instrument12: '跳绳',
        instrument13: '绳索机',
        instrument14: '牧师凳',
        instrument15: '六角杠铃',
        instrument16: '腿弯举机',
        instrument17: '杠铃',
        instrument18: '哑铃',
        instrument19: '坐姿提踵机',
        instrument20: '高位下拉机',
        instrument21: 'T杠铃',
        instrument22: '史密斯机',
        instrument23: '卷腹机',
        instrument24: '其他',
        instrument25: '绳索',
        muscles1: '斜方肌',
        muscles2: '胸大肌',
        muscles3: '肱二头肌',
        muscles4: '肱三头肌',
        muscles5: '前臂肌群',
        muscles6: '背阔肌',
        muscles7: '竖脊肌',
        muscles8: '臀肌',
        muscles9: '腘绳肌',
        muscles10: '腹肌',
        muscles11: '股四头肌',
        muscles12: '内收肌',
        muscles13: '外展肌',
        muscles14: '小腿肌群',
        muscles15: '三角肌',
        detailBtn: '详细介绍'
    },
    actionDesc: {
        title: '动作详情',
        part: '训练部位',
        point: '动作要点',
        delete: '删除'
    },
    actionEdit: {
        title: '动作编辑',
        actionName: '动作名称',
        actionNamePlaceholder: '请输入动作名称',
        actionPart: '训练部位',
        actionPartPlaceholder: '请选择训练部位',
        actionInstrument: '训练器械',
        actionInstrumentPlaceholder: '请选择训练器械',
        recordType: '记录数据',
        recordTypePlaceholder: '请选择记录数据',
        actionBanner: '动作封面',
        actionBannerPlaceholder: '请上传动作封面',
        actionMuscles: '训练肌群',
        actionMusclesPlaceholder: '请选择训练肌群',
        actionPoint: '动作要点',
        actionPointPlaceholder: '请输入动作要点',
        save: '保存',
        selectPlaceholder: '请选择',
        recordType1: '负重和次数',
        recordType2: '仅时间',
        recordType3: '仅次数',
        recordType4: '仅距离',
        pointPlaceholder: '可以描述该动作的正确姿势、技术要点和注意事项。',
        delete: '删除动作',
        deleteTitle: '删除提示',
        deleteDesc: '确定要删除该动作吗？',
        confirm: '确认',
        cancel: '取消'
    },
    setPlanDate: {
        title: '设置训练日期',
        repeatWeek: '重复周期',
        startDate: '开始时间',
        endDate: '结束时间',
        week0: '周一',
        week1: '周二',
        week2: '周三',
        week3: '周四',
        week4: '周五',
        week5: '周六',
        week6: '周日',
        confirm: '确认',
        cancel: '取消',
        repeatTips: '请至少选择一个重复周期',
        repeatText: '每周',
        repeatText0: '一',
        repeatText1: '二',
        repeatText2: '三',
        repeatText3: '四',
        repeatText4: '五',
        repeatText5: '六',
        repeatText6: '日',
        repeatText7: '每天',
        repeatTextSplit: '、',
        import: '导入到训练日历',
        isRemind: '设置提醒',
        remindTime: '提醒时间',
        planErrorMsg: '计划不存在，请退出重试'
    },
    planLibrary: {
        title: '计划库',
        history: '历史计划',
        create: '+创建',
        progress: '进行中',
        group: '组',
        capacity: '容量',
        action: '动作',
        groupCount: '组数'
    },
    planDesc: {
        title: '计划详情',
        start: '开始训练',
        edit: '编辑',
        delete: '删除',
        out: '退出',
        outPlan: '退出计划',
        outPlanDesc: '退出训练计划后不会清除之前的运动记录，确认退出？',
        cancel: '取消',
        confirm: '确认',
        deleteTitle: '删除提醒',
        deleteDesc: '当前计划正在进行中，是否停止当前计划并删除？',
        success: '删除成功！'
    },
    trainCalendar: {
        title: '训练日历',
        seeDetail: '查看详情'
    },
    startTrain: {
        title: '开始训练',
        finish: '完成',
        action: '动作',
        group: '组',
        capacity: '容量',
        rest: '休息',
        duration: '计时',
        startTiming: '开始计时',
        feel: '训练感受',
        confirm: '确认',
        easy: '轻松',
        normal: '适中',
        hard: '困难',
        feelInput: '写下你今天的训练心得和认为值得注意的事项'
    },
    sportTrainDesc: {
        title: '运动详情',
        rest: '休息时长',
        cal: '运动能耗',
        hr: '心率',
        hrUnit: '次/分',
        max: '最高',
        min: '最低',
        avg: '平均',
        hrRange0: '极限区间',
        hrRange1: '无氧区间',
        hrRange2: '耐力区间',
        hrRange3: '有氧区间',
        hrRange4: '热身区间',
        trainEffect: '训练效果',
        trainFeel: '训练感受',
        trainParts: '训练部位',
        effect0: '恢复力',
        effect1: '爆发力',
        effect2: '耐力',
        effect3: '力量',
        effect4: '经济性',
        dataFrom: '数据来自 '
    }
};

export default zh;



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js